import { render } from "./MyButton.vue?vue&type=template&id=dc696994&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"

import "./MyButton.vue?vue&type=style&index=0&id=dc696994&scoped=true&lang=css"

import exportComponent from "/home/walnit/Documents/AppVenture/nush-bookings-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc696994"]])

export default __exports__